export default __webpack_public_path__ + "static/media/bg03.0301cbc0.jpg";